import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectUserProjectId } from 'core/userContext';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { Button, BUTTON_SIZES } from 'ui/button';
import { FormField, FormLabel } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import noop from 'utils/noop';

import { CREATE_LIST_MODAL } from '../../../constants';
import { closeModal, createList, CreateListPayload } from '../../../ducks';

export const CREATE_LIST_MODAL_BUTTON_ID = 'create-list-modal-button';

interface CreateListModalProps {
  onListCreated?: CreateListPayload['onListCreated'];
}

export const CreateListModal = ({ onListCreated = noop }: CreateListModalProps) => {
  const dispatch = useDispatch();
  const [title, setTitle] = useState<string>('');
  const projectId = useSelector(selectUserProjectId);

  const handleCloseModal = () => {
    dispatch(closeModal(CREATE_LIST_MODAL));
  };

  const handleSubmit = () => {
    if (projectId !== '') {
      dispatch(createList({ title, projectId, dispatch, onListCreated }));
    } else {
      dispatch(addNegativeToastWithErrorId('Could not get project id', 'createList'));
    }
    handleCloseModal();
  };

  return (
    <Modal
      id={CREATE_LIST_MODAL}
      isModalOpen={true}
      onClose={handleCloseModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader autoFocus={false}>New list</ModalHeader>
      <ModalBody>
        <FormField>
          <FormLabel>Audience list name</FormLabel>
          <InputText
            data-test="create-audience-list-input"
            id={'new-list-title'}
            value={title}
            onChange={setTitle}
            autoFocus
          />
        </FormField>
      </ModalBody>
      <ModalFooter>
        <Button
          data-test={CREATE_LIST_MODAL_BUTTON_ID}
          onClick={handleSubmit}
          size={BUTTON_SIZES.LARGE}
          isDisabled={!title.length}
        >
          Create list
        </Button>
      </ModalFooter>
    </Modal>
  );
};
